/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import Store from './store/store'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('@/views/paketleme/Paketlemeislemi.vue'),
                beforeEnter(to,from,next){
                    if (Store.getters.isAutState) {
                      next()
                    } else {
                      next('login')
                    }
                },
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Paketleme' },
                    { title: 'Paketleme İşlemi', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/page2',
                name: 'page-2',
                component: () => import('./views/Page2.vue'),
                beforeEnter(to,from,next){
                    if (Store.getters.isAutState) {
                      next()
                    } else {
                      next('login')
                    }
                }
              },

              {
                path: '/satis/hizlisatis',
                name: 'Satış',
                component: () => import('@/views/satis/Satis.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Satış' },
                    { title: 'Hızlı Satış', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/paketleme/magazasatis/:kategoriId',
                name: 'Satış',
                component: () => import('@/views/paketleme/MagazaSatis.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Satış' },
                    { title: 'Mağaza Satış', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/paketleme/magazasatis1/:kategoriId',
                name: 'Satış',
                component: () => import('@/views/paketleme/MagazaSatis1.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Satış' },
                    { title: 'Mağaza Satış', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/paketleme/sepet',
                name: 'Satış',
                component: () => import('@/views/paketleme/sepet.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Satış' },
                    { title: 'Satışı Tamamla', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/rapor/stoksatisrapor',
                name: 'Satış',
                component: () => import('@/views/rapor/SatisRaporu.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Rapor' },
                    { title: 'Stok Satış Raporu', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/rapor/sevkbekleyen',
                name: 'Satış',
                component: () => import('@/views/rapor/SevkBekleyen.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Rapor' },
                    { title: 'Sevk Bekleyen Stok Raporu', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/rapor/kullaniciBazli',
                name: 'Satış',
                component: () => import('@/views/rapor/KullaniciRapor.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Rapor' },
                    { title: 'Kullanıcı Bazlı Rapor', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/rapor/kargoRapor',
                name: 'Satış',
                component: () => import('@/views/rapor/kargoRapor.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Rapor' },
                    { title: 'Kargo Raporu', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/rapor/siparisRaporu',
                name: 'Satış',
                component: () => import('@/views/rapor/SiparisRaporu.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Rapor' },
                    { title: 'Sipariş Raporu', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/trendyolsipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/Trendyol.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Trendyol', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/paketkampanyasi',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/paketKampanyasi.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Paket Kampanyası', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/trendyolkategoricek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/TrendyolKategori.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Trendyol Kategori', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/pazaramakategoricek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/PazaramaKategori.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Pazarama Kategori', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/ticimaxkategoricek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/TicimaxKategori.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Ticimax Kategori', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/n11kategoricek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/N11Kategori.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'N11 Kategori', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/hepsiburadakategoricek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/HepsiburadaKategori.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Hepsiburada Kategori', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/hticaretsipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/HTicaret.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'H-Ticaret Sipariş', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/ideasoftsipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/Ideasoft.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'İdeasoft Sipariş', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/ticimaxsipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/Ticimax.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Ticimax Sipariş', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/n11sipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/N11.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'N11', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/morhiposipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/Morhipo.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Morhipo', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/pazaryeri/hepsiburadasipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/Hepsiburada.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Hepsiburada', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              }
              ,
              {
                path: '/pazaryeri/clasysipariscek',
                name: 'Satış',
                component: () => import('@/views/pazaryeri/Clasy.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Clasyevi', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              }
              ,
              {
                path: '/paketleme/paketlemeislemi',
                name: 'Satış',
                component: () => import('@/views/paketleme/Paketlemeislemi.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Paketleme' },
                    { title: 'Paketleme İşlemi', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/pazaryeri/iadekabul',
                name: 'İade',
                component: () => import('@/views/pazaryeri/iade.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'İade İşlemi', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/pazaryeri/finans',
                name: 'İade',
                component: () => import('@/views/pazaryeri/finans.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Finans İşlemi', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },{
                path: '/pazaryeri/stoklistesi',
                name: 'Stok Listesi',
                component: () => import('@/views/pazaryeri/stokListesi.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Pazaryeri' },
                    { title: 'Stok Listesi', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              },
              {
                path: '/paketleme/hizlisatis',
                name: 'Satış',
                component: () => import('@/views/paketleme/hizliSatis.vue'),
                beforeEnter(to,from,next){
                  if (Store.getters.isAutState) {
                    next()
                  } else {
                    next('login')
                  }
              },
              
                meta: {
                  breadcrumb: [
                    { title: 'Ana Sayfa', url: '/' },
                    { title: 'Satış' },
                    { title: 'Hızlı Satış', active: true }
                  ],
                  requiresAuth: true,
                  //pageTitle: 'Hızlı Satış',
                  rule: 'editor'
                }
              }

            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
